import React, { useState } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';
import style from './style.scss';

import supportSvg from './icons/support.svg';
import emailSvg from './icons/email.svg';
import telegramSvg from './icons/telegram.svg';
import whatsupSvg from './icons/whatsup.svg';
import arrowSvg from './icons/arrow.svg';
import arrowRight from './icons/arrow-right.svg';
import { useLocation } from 'react-router';

const deniedUrls = [
  'nbref',
  'ncollection',
  'rates'
];

const Support = React.memo(() => {
  const [isOpen, setIsOpen] = useState(false);
  const authenticated = useSelector(state => state.authentication.authenticated, shallowEqual);
  const { t } = useTranslation();
  const location = useLocation();

  if (!authenticated) {
    return null;
  }

  if (deniedUrls.find(url => location.pathname.includes(url))) {
    return null;
  }

  return (
    <div className={style.SupportContainer}>
      <span
        onClick={() => setIsOpen(prev => !prev)}
        className={style.SupportContainerButton}
        title={t('components.support.title')}
      >
        {isOpen ? <img style={{ transform: 'rotate(90deg)' }} src={arrowRight} /> : <img alt="" src={supportSvg} />}
      </span>
      {isOpen && (
        <div className={style.SupportTable}>
          <div className={cn(style.SupportTableTitle, style.Border)}>
            {t('components.support.title')}
          </div>
          <a
            href="https://api.whatsapp.com/send/?phone=79683000112"
            target="_blank"
            rel="noopener noreferrer"
            className={style.SupportTableRow}
          >
            <div>
              <img alt="" src={whatsupSvg} />
            </div>
            <div className={style.Border}>
              {t('components.support.whatsup')}
            </div>
          </a>
          <a
            href="https://t.me/Nedvex_App"
            target="_blank"
            rel="noopener noreferrer"
            className={style.SupportTableRow}
          >
            <div>
              <img alt="" src={telegramSvg} />
            </div>
            <div className={style.Border}>
              {t('components.support.telegram')}
            </div>
          </a>
          <a
            href="mailto:content@nedvex.ru?Subject=Обращение в техническую поддержку"
            className={style.SupportTableRow}
          >
            <div>
              <img alt="" src={emailSvg} />
            </div>
            <div>
              {t('components.support.email')}
            </div>
          </a>
          <div className={style.SupportTableArrow}>
            <img alt="" src={arrowSvg} />
          </div>
        </div>
      )}
    </div>
  );
});

export default Support;



// WEBPACK FOOTER //
// ./src/components/Support/index.jsx